export default "__VITE_ASSET__b1b62c28__"